import React from "react";
import PricePageSection from "../sections/PricePageSection/Content";
const PricePage = () => {
  return <PricePageSection />;
};

export default PricePage;
